/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Resource } from '../../models/resource';

export interface GetRestrictedResources$Params {
  bookId: string;
}

export function getRestrictedResources(http: HttpClient, rootUrl: string, params: GetRestrictedResources$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Resource>>> {
  const rb = new RequestBuilder(rootUrl, getRestrictedResources.PATH, 'get');
  if (params) {
    rb.query('bookId', params.bookId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Resource>>;
    })
  );
}

getRestrictedResources.PATH = '/api/agn-resources/restricted-resources';
